import { Grid } from '@material-ui/core';
import { _NkInput as NkInput } from '@nordkap/nordkap-ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../hooks/useDebounce';
import { emptyGuid } from '../../utils/constants';
import { combineClasses } from '../../utils/styling';
import { useStyles } from './styles';
import {
  row,
  ruleRowFieldsSize,
  ruleRowNameSize,
  TemplateContainer,
  templateNameSize,
} from './utils';

const TemplateName = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [name, setName] = useState('');
  const templateContainer = TemplateContainer.useContainer();
  const debouncedValue = useDebounce(name, 300);

  const changeName = event => {
    setName(event.target.value);
  };

  useEffect(() => {
    setName(props.positionTemplate.name);
  }, [props.positionTemplate.name]);

  useEffect(() => {
    templateContainer.setTemplateName(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  return (
    <Grid container item xs={row} classes={{ root: classes.EventTypeForm }}>
      <Grid
        item
        {...ruleRowNameSize}
        classes={{ root: classes.EventTypeNameHeader }}
      >
        <p
          className={combineClasses([
            classes.Bold,
            classes.UpperCase,
            classes.EventTypeName,
          ])}
        >
          {t('positionPage.template')}
        </p>
      </Grid>
      <Grid
        container
        item
        justifyContent="flex-start"
        alignItems="stretch"
        {...ruleRowFieldsSize}
        classes={{ root: classes.TemplateNameRow }}
      >
        <Grid
          container
          item
          alignItems="flex-end"
          justifyContent="space-evenly"
          wrap="nowrap"
          direction="column"
          {...templateNameSize}
        >
          <Grid container item xs={row}>
            <label
              className={combineClasses([
                classes.Bold,
                classes.UpperCase,
                classes.FieldLabel,
              ])}
            >
              {t('positionTemplate.name')}
            </label>
          </Grid>
          <Grid container item xs={row}>
            <NkInput
              name={t('positionTemplate.name')}
              placeholder={t('positionTemplate.name')}
              type="text"
              variant="outlined"
              value={name}
              onChange={changeName}
              errorText={t('global.form.required')}
              isValid={name && name !== ''}
              required
              inputClasses={{ root: classes.FieldBackground }}
            />
          </Grid>
        </Grid>
        {props.positionTemplate.positionTemplateId &&
        props.positionTemplate.positionTemplateId !== emptyGuid ? (
          <>
            <Grid
              container
              item
              alignItems="flex-end"
              justifyContent="space-evenly"
              wrap="nowrap"
              direction="column"
              {...templateNameSize}
            >
              <Grid
                container
                item
                xs={row}
                classes={{ root: classes.UsageField }}
              >
                <label
                  className={combineClasses([
                    classes.Bold,
                    classes.UpperCase,
                    classes.FieldLabel,
                    classes.UsageLabel,
                  ])}
                >
                  {t('positionTemplate.usage')}
                </label>
                <label
                  className={combineClasses([
                    classes.Bold,
                    classes.UpperCase,
                    classes.FieldLabel,
                    classes.UsageValue,
                  ])}
                >
                  {props.positionCount}
                </label>
              </Grid>
            </Grid>
            {props.positionTemplate.archived ? (
              <Grid
                container
                item
                alignItems="flex-end"
                justifyContent="space-evenly"
                wrap="nowrap"
                direction="column"
                {...templateNameSize}
              >
                <Grid
                  container
                  item
                  xs={row}
                  classes={{ root: classes.UsageField }}
                  alignItems="center"
                >
                  <label
                    className={combineClasses([
                      classes.Bold,
                      classes.UpperCase,
                      classes.FieldLabel,
                      classes.ArchivedLabel,
                    ])}
                  >
                    {t('positionTemplate.archived')}
                  </label>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
          </>
        ) : (
          ''
        )}
      </Grid>
    </Grid>
  );
};

TemplateName.propTypes = {
  positionTemplate: PropTypes.object,
  positionCount: PropTypes.number,
};

export default TemplateName;
